import format from 'date-fns/format';
import markdownIt from 'markdown-it';
import markdownItSup from 'markdown-it-sup';
import markdownItSanitizer from 'markdown-it-sanitizer';
import markdownItClass from '@toycode/markdown-it-class';
import markdownItLinkAttributes from 'markdown-it-link-attributes';

import { MessageTypes } from '../../../../../../../../store/types';

import './styles.scss';
import React from 'react';
import evieAvatar from '../../../../../../../../../assets/evie-avatar.svg';

type Props = {
  message: MessageTypes;
  showTimeStamp: boolean;
}

function Message({ message, showTimeStamp }: Props) {
  const sanitizedHTML = markdownIt({ break: true })
    .use(markdownItClass, {
      img: ['rcw-message-img']
    })
    .use(markdownItSup)
    .use(markdownItSanitizer)
    .use(markdownItLinkAttributes, [
      // In-app links (e.g. /cases/<id>) stay in this tab; everything else opens a new one.
      { matcher: (href: string) => href.startsWith('/'), attrs: { target: '_self' } },
      // tel:/mailto: hand off to the dialler or mail app; a new tab would be blank.
      { matcher: (href: string) => /^(tel|mailto):/i.test(href), attrs: { target: '_self' } },
      { attrs: { target: '_blank', rel: 'noopener' } },
    ])
    .render(message.text);

  const isAssistant = message.sender === 'response';

  return (
    <div className={`rcw-${message.sender}`}>
      {isAssistant && (
        <div className="rcw-avatar-wrapper">
          <img className="rcw-avatar-img" src={evieAvatar} alt="Evie avatar" />
        </div>
      )}
      <div className="rcw-message-content">
        <div className="rcw-message-text" dangerouslySetInnerHTML={{ __html: sanitizedHTML.replace(/\n$/, '') }} />
        {showTimeStamp && <span className="rcw-timestamp">{format(message.timestamp, 'hh:mm')}</span>}
      </div>
    </div>
  );
}

export default Message;
